import { getValue } from "@/shared/RxUtil";
export class GetUsersUseCaseImpl {
    constructor(usersRepository, authRepository) {
        this.usersRepository = usersRepository;
        this.authRepository = authRepository;
    }
    async run() {
        const usersPromise = this.usersRepository.getUsers();
        const currentUserIdPromise = getValue(this.authRepository.userId);
        const [users, currentUserId] = await Promise.all([usersPromise, currentUserIdPromise]);
        return users.filter(user => user.id != currentUserId);
    }
}
